import { render } from "./worker.vue?vue&type=template&id=79a60c48"
import script from "./worker.vue?vue&type=script&lang=js"
export * from "./worker.vue?vue&type=script&lang=js"

import "./worker.vue?vue&type=style&index=0&id=79a60c48&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__